// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1r4_h","productName":"Table_productName__2vQEK"};